const messages = {
  title: "Listas de precios y folletos de productos",
  description:
    "Descargue aquí los últimos folletos y material sobre nuestros neumáticos Bridgestone y Firestone para turismos, SUV y vehículos comerciales ligeros.",
  brochureCategories: {
    products: "Productos",
    brand_and_solutions: "Marca y soluciones",
    season_and_promotions: "Temporada y promociones",
    format: "Formato",
    cars_and_vans: "Turismo, SUV, comercial ligero",
    summer: "Verano",
    winter: "Invierno",
    promotions: "Promociones",
    all_season: "Todas las estaciones",
    truck_and_buses: "Pesado y autobús",
    motorcycle: "Motocicleta",
    agriculture: "Agricultura",
    construction_machinery: "Maquinaria de construcción",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiales",
    brochures: "Folletos de producto",
    price_list: "Listas de precios",
    materials: "Materiales",
    video_in_store: "Vídeo con subtítulos",
    video_online: "Vídeo sin subtítulos",
    banner_website: "Banner",
    banner_social_media: "Redes sociales",
    logos: "Logotipos",
  },
  searchMedia: "Introduzca una palabra clave",
  searchResults: "Resultados de búsqueda",
};

export default {
  messages,
};
